import { getOnlinePay, fetchOnlinePay } from "utils/api";

export const queryStatementList = async (params) => {
  return await getOnlinePay("/statement/pdf-list", {
    ...params,
  });
};

export const showStatementPdf = async (params) => {
  return await getOnlinePay("/statement/pdf-presign", {
    ...params,
  });
};

export const generateStatementPdf = async (params) => {
  return await fetchOnlinePay("/statement/pdf-generate", {
    ...params,
  });
};
